import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { api, type Briefing, type Note, type Person, type Project, type Resource, type Task } from './api.ts';

export type Dashboard = { briefings: Briefing[]; tasks: Task[]; projects: Project[]; people: Person[]; notes: Note[]; resources: Resource[] };
export const useDashboard = () => useQuery({ queryKey: ['dashboard'], queryFn: () => api<Dashboard>('/dashboard') });

export function useSave() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ path, method = 'POST', body }: { path: string; method?: string; body?: unknown }) => api(path, { method, body }),
    onSuccess: () => qc.invalidateQueries(),
  });
}

// The task drawer is addressed by ?task=<id>, so any view can open it and links are shareable.
export function useTaskDrawer() {
  const [params, setParams] = useSearchParams();
  return {
    openId: params.get('task'),
    open: (id: string) => setParams((p) => { p.set('task', id); return p; }),
    close: () => setParams((p) => { p.delete('task'); return p; }),
  };
}
